"use client";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import MenuItem from "../MenuItem/MenuItem";
import useAutoClose from "@/hooks/useAutoClose";
import { useLoggedIn } from "@/store/useAuthStore";
import { usePathname } from "next/navigation";
import CustomNavLink from "../CustomLink/CustomNavLink";
import CartTooltip from "../TopBar/component/CartTooltip";
import Hamburger from "../TopBar/component/Hamburger";
import useImageUrlModifier from "@/lib/useImageUrlModifier";

const MobileDrawer = () => {
  const { auth, profile } = useLoggedIn();
  const pathname = usePathname();
  const { tooglepopup, showPopup, ref, closepopup } = useAutoClose();
  const [bodyOverflow, setBodyOverflow] = useState("");
  const modifyImageUrl = useImageUrlModifier();

  useEffect(() => {
    setBodyOverflow(showPopup ? "hidden" : "");
  }, [showPopup]);

  useEffect(() => {
    document.body.style.overflow = bodyOverflow;

    return () => {
      document.body.style.overflow = "";
    };
  }, [bodyOverflow]);

  // const loginRedirect = () => {
  //   router.push("/login"); // Redirect to login page
  // };

  const loginRedirect = () => {
    window.location.href = pathname?.split("/")[1] == "ar" ? "/ar/login" : "/en/login"; // Redirects to the login page
  };

  return (
    <>
      {/* Drawer Trigger */}
      {auth ? (
        <>
          <div className="text-center">
            <div
              onClick={tooglepopup}
              aria-controls="drawer-navigation"
              className="cursor-pointer"
            >
              <Image
                className="lg:hidden"
                src={"/images/drawer.svg"}
                width={28}
                height={28}
                alt="drawer"
              />
            </div>
          </div>
          <CustomNavLink href="cart">
            <div className="relative">
              <Image
                className=""
                src={"/images/cart.svg"}
                width={24}
                height={24}
                alt="cart"
              />
              <CartTooltip />
            </div>
          </CustomNavLink>
        </>
      ) : (
        <>
          <Hamburger />
          <div
            aria-controls="drawer-navigation"
            className="cursor-pointer"
            onClick={loginRedirect}
          >
            <Image
              className="lg:hidden"
              src={
                modifyImageUrl(profile?.userImage, 100, 100) ||
                "/images/user.svg"
              }
              width={24}
              height={24}
              alt="user"
            />
          </div>

          <CustomNavLink href="cart">
            <div className="relative">
              <Image
                className=""
                src={"/images/cart.svg"}
                width={24}
                height={24}
                alt="cart"
              />
              <CartTooltip />
            </div>
          </CustomNavLink>
        </>
      )}

      {/* Drawer Content */}
      <div
        id="drawer-navigation"
        className={`w-full min-h-screen inset-0 fixed z-[1001] bg-opacity-50 p-4 overflow-y-auto transition-transform ${
          showPopup
            ? "bg-own-black rtl:translate-x-0 ltr:-translate-x-0"
            : "bg-transparent rtl:translate-x-full ltr:-translate-x-full"
        }  `}
        tabIndex={-1}
        aria-labelledby="drawer-navigation-label"
      >
        <div
          ref={ref}
          className="w-72 bg-white fixed top-0 ltr:left-0 rtl:right-0 z-40 min-h-screen p-4"
        >
          {/* Drawer Header */}
          <h5
            id="drawer-navigation-label"
            className="text-base font-semibold text-gray-500 uppercase "
          ></h5>
          <button
            onClick={closepopup}
            type="button"
            data-drawer-hide="drawer-navigation"
            aria-controls="drawer-navigation"
            className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute top-2.5 end-2.5 inline-flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white"
          >
            <svg
              className="w-3 h-3"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span className="sr-only">Close menu</span>
          </button>
          <div className="py-4 min-h-fit overflow-y-auto">
            <MenuItem closepopup={closepopup} />
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileDrawer;
